import React, { useState } from "react";
import "./styles.scss";

export interface KC_TabItem {
  name: string;
  value: string;
}

interface KC_TabsProps {
  className?: string;
  items: KC_TabItem[];
  onSelect: (value: string) => void;
  initialSelectedIndex?: number;
  id?: string;
}

const KC_Tabs: React.FC<KC_TabsProps> = (props: KC_TabsProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(
    props.initialSelectedIndex || 0
  );

  const handleSelect = (index: number) => {
    setSelectedIndex(index);
    props.onSelect(props.items[index].value);
  };

  return (
    <ul className={`nav nav-tabs tab-selector ${props.className}`}>
      {props.items.map((item, index) => (
        <li className="nav-item" key={item.value}>
          <button
            id={`${props.id}-toggle-${index}`}
            type="button"
            className={`nav-link ${selectedIndex === index ? "nav-link-active" : ""}`}
            onClick={() => {
              handleSelect(index);
            }}
          >
            {item.name}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default KC_Tabs;
